enum LayerType {
	Full = "FULL",
	Conv = "CONV",
	Pool = "POOL"
}

export default LayerType;